import { Logger, startGame } from 'outpost';
import { LoginRoom } from './login-room.ts';

function main() {
    Logger.configure({ level: 'info', displayTime: true });
    startGame(() => new LoginRoom());
    Logger.info('Glob started!');
}

main();